import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { audiences } from '../../data/home';
export function Audiences() {
  return <section className="w-full bg-white py-24" data-id="element-12" data-mp="1117tow72ugo0">
      <div className="mx-auto max-w-[1320px] px-6" data-id="element-13" data-mp="112j3bcn7ein1">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-14" data-mp="1601b2zphirtg">
          <h2 className="font-display max-w-2xl text-[52px] text-ink md:text-[72px]" data-id="element-15" data-mp="1tpvnxh9t0gdp">
            Une banque pour
            <br data-id="element-16" data-mp="1yoq3mach5otl" />
            chaque ambition
          </h2>
          <p className="max-w-sm text-[16px] leading-relaxed text-ink-muted" data-id="element-17" data-mp="1yo6u9i0w48r6">
            Que vous gériez votre budget familial ou la trésorerie d’une entreprise, nous avons organisé nos offres
            autour de vos besoins.
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-2" data-id="element-18" data-mp="99salc4qbc2j">
          {audiences.map(a => <article key={a.title} className="group flex flex-col overflow-hidden rounded-[28px] bg-canvas" data-id="element-19" data-mp="dbvpkaqlwysk">
              <Link to={a.path} className="relative block aspect-[16/10] overflow-hidden" tabIndex={-1} aria-hidden="true" data-id="element-20" data-mp="3fa1qwzqbw0g2">
                <img src={a.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-21" data-mp="3abgsn5umzqu9" />
              </Link>
              <div className="flex flex-1 flex-col p-8 md:p-10" data-id="element-22" data-mp="22721a1y9ie9">
                <div className="flex items-start justify-between gap-6" data-id="element-23" data-mp="20m3l9cilfb4">
                  <h3 className="font-display text-[40px] text-ink" data-id="element-24" data-mp="3t7yo9yclwavs">{a.title}</h3>
                  <Link to={a.path} aria-label={`Découvrir l’offre ${a.title}`} className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-leaf transition-transform duration-200 ease-out hover:rotate-45" data-id="element-25" data-mp="bsjk8vmakzh8">
                    <ArrowUpRightIcon className="h-5 w-5" data-id="element-26" data-mp="fv6fl6i692j6" />
                  </Link>
                </div>
                <p className="mt-3 max-w-md text-[16px] leading-relaxed text-ink-muted" data-id="element-27" data-mp="39n4nrgw4xv0g">{a.text}</p>
                <ul className="mt-auto flex flex-wrap gap-2 pt-8" data-id="element-28" data-mp="3elporij7oipy">
                  {a.links.map(l => <li key={l.path} data-id="element-29" data-mp="3ikyi4macaekz">
                      <Link to={l.path} className="inline-block rounded-full border border-ink/10 bg-white px-4 py-2 text-[14px] text-ink transition-colors hover:border-brand hover:text-brand" data-id="element-30" data-mp="3nd8985n6xkou">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}